import type { ComponentMeta } from "@circle-react-shared/BuilderUI/BuilderUI.types";
import { BasicBlock } from "@circle-react-shared/BuilderUI/constants/BlockCategories";
import { backgroundColor } from "@circle-react-shared/BuilderUI/constants/DefaultStyleAttributes/backgroundColor";
import { borderColor } from "@circle-react-shared/BuilderUI/constants/DefaultStyleAttributes/borderColor";
import { borderRadius } from "@circle-react-shared/BuilderUI/constants/DefaultStyleAttributes/borderRadius";
import { color } from "@circle-react-shared/BuilderUI/constants/DefaultStyleAttributes/color";
import { fontSize } from "@circle-react-shared/BuilderUI/constants/DefaultStyleAttributes/fontSize";
import { fontWeight } from "@circle-react-shared/BuilderUI/constants/DefaultStyleAttributes/fontWeight";
import { padding } from "@circle-react-shared/BuilderUI/constants/DefaultStyleAttributes/padding";
import { textTransform } from "@circle-react-shared/BuilderUI/constants/DefaultStyleAttributes/textTransform";
import {
  BorderProp,
  ColorsProp,
  ContentProp,
  DesignProp,
  GeneralProp,
  PaddingsProp,
} from "@circle-react-shared/BuilderUI/constants/PropCategories";
import { defaultStyles } from "./defaultStyles";

export const meta: ComponentMeta = {
  name: "Badge",
  version: 1,
  nameI18n: "builder_ui.block_type.badge",
  category: [BasicBlock],
  props: {
    text: {
      name: "Text",
      nameI18n: "builder_ui.prop_type.text",
      category: [ContentProp],
      prop: "other",
      type: "rich-text",
    },
    styles: {
      name: "Styles",
      nameI18n: "builder_ui.prop_type.styles",
      category: [DesignProp],
      prop: "styles",
      type: "styles",
      attributes: {
        color: {
          ...color,
          defaultValue: defaultStyles.color,
          category: [DesignProp, ColorsProp],
        },
        backgroundColor: {
          ...backgroundColor,
          defaultValue: defaultStyles.backgroundColor,
          category: [DesignProp, ColorsProp],
        },
        borderRadius: {
          ...borderRadius,
          defaultValue: defaultStyles.borderRadius,
          category: [DesignProp, BorderProp],
        },
        borderColor: {
          ...borderColor,
          defaultValue: defaultStyles.borderColor,
          category: [DesignProp, BorderProp],
        },
        textTransform: {
          ...textTransform,
          defaultValue: defaultStyles.textTransform,
          category: [DesignProp, GeneralProp],
        },
        fontWeight: {
          ...fontWeight,
          defaultValue: defaultStyles.fontWeight,
          category: [DesignProp, GeneralProp],
        },
        fontSize: {
          ...fontSize,
          defaultValue: defaultStyles.fontSize,
          category: [DesignProp, GeneralProp],
        },
        padding: {
          ...padding,
          defaultValue: defaultStyles.padding,
          category: [DesignProp, PaddingsProp],
        },
      },
    },
  },
};
